import { memo, useEffect, useState } from "react";
import { WarningRounded } from "@mui/icons-material";
import {
  ACCOUNT_RESTRICTED__TYPE,
  FINOPAY_SUPPORT_MAIL,
  FINOPAY_SUPPORT_TEL_NG,
} from "@zenith/data/constants";

export type AccountFreezeStatusType =
  | "CREDIT_FREEZE"
  | "DEBIT_FREEZE"
  | "TOTAL_FREEZE"
  | "NOT_FROZEN";

export interface RestrictedAccountComponentProps {
  accountFreezeStatus?: AccountFreezeStatusType;
  freezeStatusMessage?: string;
}

const RestrictedAccountCheck = memo(function ReRestrictedAccountCheck(
  props: RestrictedAccountComponentProps
) {
  const [restricted, setRestricted] = useState<boolean>(false);
  const { accountFreezeStatus, freezeStatusMessage } = props;
  const { DEBIT_FREEZE, CREDIT_FREEZE, TOTAL_FREEZE } =
    ACCOUNT_RESTRICTED__TYPE;

  useEffect(() => {
    const validFreezeStatuses = [CREDIT_FREEZE, DEBIT_FREEZE, TOTAL_FREEZE];
    setRestricted(validFreezeStatuses.includes(accountFreezeStatus || ""));

    return () => setRestricted(false);
  }, [accountFreezeStatus]);

  return (
    <div
      className={`${
        restricted ? "flex items-center gap-3 md:gap-6" : " hidden "
      } my-5 rounded-xl bg-yellow-100 px-3 py-2`}
      role="alert"
    >
      <WarningRounded className="text-yellow-500" />
      <span
        className="block text-sm text-neutral-850 sm:inline md:mr-12"
        dangerouslySetInnerHTML={{ __html: freezeStatusMessage || "" }}
      />
    </div>
  );
});

export default RestrictedAccountCheck;
